import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stateToPersist: {},
  tableDefaults: {}
};

export const labelTemplateSearchSlice = createSlice({
  name: "labelTemplateSearch",
  initialState,
  reducers: {
    saveBeforeNavigateToMaintenance: (state, { payload }) => {
      state.stateToPersist = payload.state;
      state.tableDefaults = payload.tableDefaults;
    },
    resetMaintenancePersistedData: () => {
      return { ...initialState };
    },
    removeDeleteTablePersistedData: (state, { payload }) => {
      state.stateToPersist = {
        ...state.stateToPersist,
        tableData: payload
      };
    }
  }
});

export default labelTemplateSearchSlice.reducer;
